<template>
    <div>
        <div class="flex border-t -mb-px border-gray-200" :class="innerClass">
            <div class="flex-1 border-r border-l border-gray-200 px-2 py-1 -ml-px" :class="'pl-'+(2+(depth*4))"
                 v-text="title"></div>
            <div class="w-32 border-r border-gray-200 px-2 py-1 -ml-px text-right"
                 v-text="toCurrency(resolveNumericText(budget?budget.budget:0))"></div>
            <div class="w-32 border-r border-gray-200 px-2 py-1 -ml-px text-right"
                 v-text="toCurrency(resolveNumericText(budget?budget.budgetToDate:0))"></div>
            <div class="w-32 border-r border-gray-200 px-2 py-1 -ml-px text-right"
                 v-text="toCurrency(resolveNumericText(budget?budget.costToDate:0))"></div>
            <div class="w-32 border-r border-gray-200 px-2 py-1 -ml-px text-right"
                 v-text="toCurrency(resolveNumericText(budget?budget.budgetToDate:0)  - resolveNumericText(budget?budget.costToDate:0))"></div>
        </div>
        <slot></slot>
    </div>
</template>

<script>

import {toCurrency, resolveNumericText} from "../../utils";
import UiDropdown from "../ui/UiDropdown.vue";
import PageCell from "../ui/PageCell.vue";
import * as math from "mathjs";

export default {
    components: {PageCell, UiDropdown},
    props: {
        title: String,
        budget: Object,
        depth: 0,
        innerClass: {
            type: String,
            default: "bg-white"
        },
    },
    data() {
        return {
            resolveNumericText,
            toCurrency,
        }
    },
    computed: {},
    methods: {},
    mounted() {
    }
}
</script>
